<template>
    <v-container fluid class="pt-0">
        <v-row align="center" justify="center">
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh">
                    <!-- <v-fab-transition>
                        <v-btn color="pink" style="margin-top:70px" fab dark absolute left>
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-fab-transition> -->
                </v-sheet>
            </v-col>

            <v-col cols="12" lg="6" md="6" style="position:relative; top: -60px" v-if="course">

                <v-col cols="12" class="mb-4 elevation-2 red lighten-2 text-white" v-if="!course.verified">
                    <h2 class="white--text">Atención</h2>
                    <h3 class="white--text">Recuerda realizar los pagos pendientes para conservar tu lugar en el curso.</h3>
                </v-col>
                <v-app-bar dark color="008dd4">
                    <v-card-title  class="pb-0"><v-icon color="#008dd4" class="mx-1">mdi-bookshelf</v-icon> Mis cursos</v-card-title>
                    <template v-slot:extension>
                        <v-tabs v-model="tabs" align-with-title center-active>
                            <v-tabs-slider color="#fff"></v-tabs-slider>
                            <v-tab v-for="course in courses" :key="course.id" @click="change_course(course)">
                                {{ course.language.language }}
                            </v-tab>
                            <v-tab  :key="0">
                                Agregar Curso
                            </v-tab>
                        </v-tabs>
                    </template>
                </v-app-bar>
                <v-tabs-items v-model="tabs">
                    <v-tab-item v-for="course in courses" :key="course.id">
                        <v-card>
                            <v-card-text>
                                <v-row align="center" justify="center">
                                    <v-col lg="6" md="6" sm="12" xs="12" class="text-center">
                                        <h2 class="mb-3">{{ course.name }}</h2>
                                        <h3>Modalidad : <strong>{{ course.modality.name }}</strong></h3>
                                        <h3>Nivel : <strong>{{ course.level.name }}</strong></h3>
                                        <h3>Fecha de inicio : <strong>{{ course.start_date }}</strong></h3>
                                    </v-col>

                                    <v-col lg="6" md="6" sm="12" xs="12">
                                        <v-img class="ml-auto" src="/images/curso.png" fluid></v-img>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-alert :value="course.lesson.length" class="mt-4" color="success" outlined text transition="scale-transition" icon="mdi-play" prominent>
                            <v-row align="center">
                                <v-col class="grow">
                                    Accede y evalúa tu clase del día de hoy
                                </v-col>
                                <v-col class="shrink">
                                    <v-btn text color="success" outlined @click="redirect_and_evaluate()">acceder</v-btn>
                                </v-col>
                            </v-row>
                        </v-alert>

                        <v-alert :value="show_current_lesson" class="mt-4" color="success" outlined text transition="scale-transition" icon="mdi-play" prominent>
                            <v-row align="center">
                                <v-col class="grow">
                                    Accede y evalúa tu clase del día de hoy
                                </v-col>
                                <v-col class="shrink">
                                    <v-btn text color="success" outlined @click="redirect_and_evaluate()">acceder</v-btn>
                                </v-col>
                            </v-row>
                        </v-alert>

                        <v-card class="mt-4">
                            <v-card-title>Horario</v-card-title>
                            <v-card-text>
                                <v-row align="center" justify="center">
                                    <v-col cols="12">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th>Día</th>
                                                        <th>Hora de inicio</th>
                                                        <th>Hora de termino</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(schedule, index) in course.schedule" :key="index">
                                                        <td>{{ schedule.day }}</td>
                                                        <td>{{ schedule.start_time+" (GMT-6)" }}</td>
                                                        <td>{{ schedule.end_time+" (GMT-6)" }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card class="mt-4">
                            <v-card-title>Documentos</v-card-title>
                            <v-card-text v-if="course.materials.length > 0">
                                <v-list two-line>
                                    <v-list-item-group>
                                        <template v-for="(material, index) in course.materials">
                                            <v-list-item :key="index">
                                                <template v-slot:default="{ active }">
                                                    <v-list-item-content>
                                                        <v-list-item-title v-text="material.title"></v-list-item-title>
                                                        <v-list-item-subtitle v-text="material.description"></v-list-item-subtitle>
                                                    </v-list-item-content>

                                                    <v-list-item-action>
                                                        <v-list-item-action-text v-text="material.date"></v-list-item-action-text>
                                                        <v-btn icon :href="download_url+material.folio">
                                                            <v-icon>mdi-download</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                </template>
                                            </v-list-item>
                                            <v-divider v-if="index < course.materials.length - 1" :key="index"></v-divider>
                                        </template>
                                    </v-list-item-group>
                                </v-list>
                            </v-card-text>
                            <v-card-text class="text-center" v-else>
                                <p>Aún no tienes documentos de este curso registrados</p>
                            </v-card-text>
                        </v-card>

                        <v-card class="mt-4">
                            <v-card-title>
                                <v-row justify="center" align="center">
                                    <v-col>Grabaciones</v-col>
                                    <v-col>
                                        <v-select v-model="change_course_recordings" no-data-text="Sin registros anteriores" outlined dense label="Cursos anteriores" :items="old_courses" item-text="course.name" item-value="course.id"></v-select>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-text v-if="recordings.length > 0">
                                <v-card v-for="(record, index) in recordings" :key="index" class="mb-3" outlined>
                                    <v-list-item three-line>
                                        <v-list-item-content>
                                            <div class="overline mb-4">{{ record.date }}</div>
                                            <v-list-item-title class="mb-1">
                                                <strong>
                                                    {{ record.name }}
                                                </strong>
                                            </v-list-item-title>
                                            <v-list-item-subtitle>{{ record.description }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-avatar tile size="80">
                                        <v-img :src="initial_avatar+record.name+final_avatar"></v-img>
                                        </v-list-item-avatar>
                                    </v-list-item>
                                    <v-card-actions>
                                        <v-btn text :href="'/watch/'+record.folio">
                                            <v-icon class="mr-3" color="red">mdi-play-circle</v-icon>
                                            ver
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-card-text>
                            <v-card-text class="text-center" v-else>
                                <p>Aún no tienes grabaciones de este curso registradas</p>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card-text>
                            <v-row align="center" justify="center">
                                <v-col lg="6" md="6" sm="12">
                                    <div class="text-center" >
                                        <h2 class="mb-3" >Inscribirse a un curso</h2>
                                    </div>

                                </v-col>
                                <v-col lg="6" md="6" sm="12">
                                    <v-img src="/images/curso.png" fluid max-width="300" class="mx-auto"></v-img>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-btn  block text color="#008dd4" :href="select_course_url"><strong>Seleccionar curso</strong></v-btn>
                    </v-tab-item>
                </v-tabs-items>
            
                <!--
                <v-card>
                    <v-card-title>Mi cursos</v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col lg="6" md="6" sm="12" xs="12" class="text-center">
                                <h2 class="mb-3">{{ course.name }}</h2>
                                <h3>Modalidad : <strong>{{ course.modality.name }}</strong></h3>
                                <h3>Nivel : <strong>{{ course.level.name }}</strong></h3>
                                <h3>Fecha de inicio : <strong>{{ course.start_date }}</strong></h3>
                            </v-col>

                            <v-col lg="6" md="6" sm="12" xs="12">
                                <v-img class="ml-auto" src="/images/curso.png" fluid></v-img>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-alert :value="show_current_lesson" class="mt-4" color="success" outlined text transition="scale-transition" icon="mdi-play" prominent>
                    <v-row align="center">
                        <v-col class="grow">
                            Accede y evalúa tu clase del día de hoy
                        </v-col>
                        <v-col class="shrink">
                            <v-btn text color="success" outlined @click="redirect_and_evaluate()">acceder</v-btn>
                        </v-col>
                    </v-row>
                </v-alert>

                <v-card class="mt-4">
                    <v-card-title>Horario</v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col cols="12">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>Día</th>
                                                <th>Hora de inicio</th>
                                                <th>Hora de termino</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(schedule, index) in course.schedule" :key="index">
                                                <td>{{ schedule.day }}</td>
                                                <td>{{ schedule.start_time+" (GMT-6)" }}</td>
                                                <td>{{ schedule.end_time+" (GMT-6)" }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title>Documentos</v-card-title>
                    <v-card-text v-if="course.materials.length > 0">
                        <v-list two-line>
                            <v-list-item-group>
                                <template v-for="(material, index) in course.materials">
                                    <v-list-item :key="index">
                                        <template v-slot:default="{ active }">
                                            <v-list-item-content>
                                                <v-list-item-title v-text="material.title"></v-list-item-title>
                                                <v-list-item-subtitle v-text="material.description"></v-list-item-subtitle>
                                            </v-list-item-content>

                                            <v-list-item-action>
                                                <v-list-item-action-text v-text="material.date"></v-list-item-action-text>
                                                <v-btn icon :href="download_url+material.folio">
                                                    <v-icon>mdi-download</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </template>
                                    </v-list-item>
                                    <v-divider v-if="index < course.materials.length - 1" :key="index"></v-divider>
                                </template>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                    <v-card-text class="text-center" v-else>
                        <p>Aún no tienes documentos de este curso registrados</p>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title>
                        <v-row justify="center" align="center">
                            <v-col>Grabaciones</v-col>
                            <v-col>
                                <v-select v-model="change_course_recordings" no-data-text="Sin registros anteriores" outlined dense label="Cursos anteriores" :items="old_courses" item-text="course.name" item-value="course.id"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text v-if="recordings.length > 0">
                        <v-card v-for="(record, index) in recordings" :key="index" class="mb-3" outlined>
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="overline mb-4">{{ record.date }}</div>
                                    <v-list-item-title class="mb-1">
                                        <strong>
                                            {{ record.name }}
                                        </strong>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{ record.description }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-avatar tile size="80">
                                   <v-img :src="initial_avatar+record.name+final_avatar"></v-img>
                                </v-list-item-avatar>
                            </v-list-item>
                            <v-card-actions>
                                <v-btn text :href="'/watch/'+record.folio">
                                    <v-icon class="mr-3" color="red">mdi-play-circle</v-icon>
                                    ver
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-card-text>
                    <v-card-text class="text-center" v-else>
                        <p>Aún no tienes grabaciones de este curso registradas</p>
                    </v-card-text>
                </v-card>
                -->
            </v-col>

            <!--
            <v-col v-else cols="12" lg="6" md="6" style="position:relative; top: -60px">
                <v-card>
                    <v-card-title>Mi curso</v-card-title>
                    <v-card-text>
                        <v-row justify="center" align="center">
                            <v-col lg="6" md="6" sm="12" xs="12" class="text-center">
                                <div class="text-center">
                                    <h2 class="mb-3" >Aún no estás inscrito a ningún curso</h2>
                                    <v-btn outlined color="#000" :href="select_course_url">Seleccionar curso</v-btn>
                                </div>
                            </v-col>
                            <v-col lg="6" md="6" sm="12" xs="12">
                                <v-img class="ml-auto" src="/images/curso.png" fluid></v-img>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            -->
        </v-row>

        <template v-if="show_current_lesson " transition="scale-transition">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn fab fixed bottom right x-large color="success" class="ma-5" v-bind="attrs" v-on="on" @click="lesson_dialog = true">
                        <v-icon>mdi-play</v-icon>
                    </v-btn>
                </template>
                <span>Clase de hoy</span>
            </v-tooltip>
        </template>

        <v-dialog v-model="lesson_dialog" max-width="800" persistent>
            <v-card>
                <v-card-title>Atención</v-card-title>
                <v-card-text>
                    <strong>
                        Por favor recuerda evaluar tu clase, esto nos ayudará a mejorar la calidad y ofrecerte un mejor servicio.
                    </strong>
                    <v-alert class="my-5" type="info" text>
                        Si no fuiste redireccionado automáticamente, Has clic en el siguente enlace
                        <v-divider></v-divider>
                        <a :href="lesson.meet_url" target="_blank">
                            {{ lesson.meet_url }}
                        </a>
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="lesson_dialog = false">Cancelar</v-btn>
                    <v-btn dark color="#008dd4" @click="() => { lesson_dialog = false; evaluation_dialog = true }">Evaluar clase</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="evaluation_dialog" max-width="800" persistent>
            <v-card>
                <v-card-title>Evaluación</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text-center">
                    <v-row justify="center" align="center">
                        <v-col class="text-right">Pésima</v-col>
                        <v-col>
                            <v-rating v-model="rating_class" color="warning" length="5" size="38" class="py-4" hover></v-rating>
                        </v-col>
                        <v-col class="text-left">Excelente</v-col>
                    </v-row>
                    <v-textarea v-model="comment" filled label="Comentarios" placeholder="Solo el departamento de calidad podrá ver tu comentario para mejorar tus clases y en ningún caso el docente podrá ver tu comentario o tu identidad."></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text  @click="evaluation_dialog = false">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark @click="send_evaluation()">Evaluar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['course', 'old_courses', 'languages','courses'],
    data: () => ({
        select_course_url:"/my-courses/select-course",
        initial_avatar:"https://ui-avatars.com/api/?name=",
        final_avatar:"&background=random",
        download_url:"/class-materials/download/",
        change_course_recordings:"",
        recordings:[],

        show_current_lesson:false,
        lesson_dialog:false,

        evaluation_dialog:false,
        rating_class:3,
        comment:"",

        lesson:"",
        tabs: null,
        tab: null,
        course_id: 0,
    }),

    mounted(){
        this.listening_for_changes();
        this.courses_id = this.courses.length > 0 ? this.courses[0].id : 0;
        this.recordings = this.course.recordings

        if(Array.isArray(this.course.lesson) && this.course.lesson.length > 0)
        {
            this.show_current_lesson = true
            this.lesson = this.course.lesson[0]
        }
    },

    watch:{
        
        'change_course_recordings':function(val)
        {
            this.recordings = []
            axios.get("/my-courses", {params:{ course_id:val, ajax:true }}).then(response => {
                this.recordings = response.data.recordings
            })
        }
    },

    methods: {
        change_course:function(course){
            this.course_id = course.id
            this.recordings = []
            axios.get("/my-courses", {params:{ course_id:course.id, ajax:true }}).then(response => {
                this.recordings = response.data.recordings
            })
        },
        listening_for_changes:function(){
            this.courses.forEach(course => {
                Echo.channel('course.'+ course.id)
                    .listen('.NewLessonLinkEvent', (e) => {
                        this.lesson = e.lesson
                        this.show_current_lesson = true
                        this.course_id = course.id
                    });

            });
            // Echo.channel('course.'+this.course.id)
            // .listen('.NewLessonLinkEvent', (e) => {
            //     this.lesson = e.lesson
            //     this.show_current_lesson = true
            // });

        },

        redirect_and_evaluate:function()
        {
            let data = {}
            data.lesson_id = this.lesson.id

            axios.post("/lessons/assistance", data).then(response => {
                window.open(this.lesson.meet_url)
                this.lesson_dialog = true

            }).catch(error => {
                console.log(this.lesson)
            })
        },

        send_evaluation:function()
        {
            let data = {}
            data.rating    = this.rating_class
            data.comment   = this.comment
            data.lesson_id = this.lesson.id

            axios.post('/evaluations/store', data).then(response => {
                this.evaluation_dialog = false
                iziToast.success({
                    title:"Correcto",
                    message:"Gracias por evaluar tu clase.",
                    position:"topRight",
                })
            }).catch(error => {

            })
        }
    }
}
</script>
